const config = require("../config.js");
const apiURL = config.apiURL;
const api = {
  apiRequest(p9878, p9879, p9880 = {}) {
    for (let v7973 in p9880) {
      if (p9880[v7973] == null) {
        delete p9880[v7973];
      }
    }
    let v7974 = new URLSearchParams(p9880).toString();
    let v7975 = "" + apiURL + p9879 + (v7974 ? "?" + v7974 : "");
    return fetch(v7975).then(p9881 => p9881.json()).catch(p9882 => p9878(p9882, null)).then(p9883 => p9878(null, p9883));
  },
  apiRequestAsync(p9884, p9885 = {}) {
    return new Promise(p9886 => {
      for (let v7976 in p9885) {
        if (p9885[v7976] == null) {
          delete p9885[v7976];
        }
      }
      let v7977 = new URLSearchParams(p9885).toString();
      let v7978 = "" + apiURL + p9884 + (v7977 ? "?" + v7977 : "");
      fetch(v7978).then(p9887 => p9887.json()).catch(p9888 => p9886([p9888, null])).then(p9889 => p9886([null, p9889]));
    });
  },
  apiPost(p9890, p9891, p9892 = {}, p9893) {
    for (let v7979 in p9892) {
      if (p9892[v7979] == null) {
        delete p9892[v7979];
      }
    }
    return fetch("" + (p9893 || apiURL) + p9891, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      body: JSON.stringify(p9892)
    }).then(p9894 => p9894.json()).catch(p9895 => p9890(p9895, null)).then(p9896 => p9890(null, p9896));
  },
  listMaps(p9897, p9898, p9899, p9900) {
    this.apiRequest(p9900, "/webhooks/general/maps/list", {
      index: p9897,
      pos: p9898,
      accountId: p9899
    });
  },
  listMapsAsync(p9901, p9902, p9903) {
    return this.apiRequestAsync("/webhooks/general/maps/list", {
      index: p9901,
      pos: p9902,
      accountId: p9903
    });
  },
  searchMap(p9904, p9905, p9906) {
    this.apiRequest(p9906, "/webhooks/general/maps/search", {
      val: p9904,
      cat: p9905
    });
  },
  getMapPreset(p9907, p9908) {
    this.apiRequest(function (p9909, p9910) {
      p9910 = p9910 || {};
      p9908(p9907, p9910.da, p9910.fu);
    }, "/webhooks/general/maps/config", {
      mn: p9907
    });
  },
  listMods(p9911, p9912, p9913, p9914) {
    this.apiRequest(p9914, "/webhooks/general/mods/list", {
      index: p9911,
      pos: p9912,
      accountId: p9913
    });
  },
  searchMod(p9915, p9916) {
    this.apiRequest(p9916, "/webhooks/general/mods/search", {
      val: p9915
    });
  },
  listAssets(p9917, p9918, p9919, p9920, p9921) {
    this.apiRequest(p9921, "/webhooks/general/assets/list", {
      index: p9917,
      cat: p9920,
      username: p9919
    });
  },
  searchAsset(p9922, p9923, p9924) {
    this.apiRequest(p9924, "/webhooks/general/assets/search", {
      index: 2,
      cat: p9923,
      val: p9922
    });
  },
  getPrices(p9925) {
    this.apiRequest(p9925, "/webhooks/general/items/prices");
  },
  listStreams(p9926, p9927) {
    this.apiRequest(p9927, "/streams", {
      index: p9926
    });
  }
};
module.exports = api;